import {EmailInput} from '../../EmailInput/EmailInput';
import {useFieldProps} from '../hooks/useFieldProps';
import {EmailRendererResponseBody} from '../types/modelSchema';

export function EmailRenderer(props: EmailRendererResponseBody) {
  const {name, tooltip} = props;
  const {onChange, onBlur, onFocus, value, isRequired, error} = useFieldProps(props);

  return (
    <EmailInput
      label={props.label}
      placeholder={props.placeholder}
      data-testid={name}
      isRequired={isRequired}
      errorMessage={error?.message}
      onChange={onChange}
      onFocus={onFocus}
      onBlur={onBlur}
      tooltip={tooltip}
      value={value || ''}
      isDisabled={props.isReadOnly}
    />
  );
}
